import { IClientSite } from "./IClientSite";
import { ISite } from "./ISite";

export class Site implements ISite {
  siteId: number;
  siteName: string;
  streetAddress: string;
  postCode: string;
  cityName: string;
  County: string;
  Town: string;
  siteCode: string;
  Active: boolean;
  cityId: number;
  Client: string[];
  SiteClients: IClientSite[];

  /**
   *
   * @param id
   * @param name
   * @param streetAddress
   * @param postCode
   * @param cityName
   * @param siteCode
   * @param County
   *  @param Town
   * @param Active
   * @param cityId
   * @param client
   * @param SiteClients
   *
   */
  constructor(
    id: number,
    name: string,
    streetAddress: string,
    postCode: string,
    cityName: string,
    county: string,
    town: string,
    siteCode: string,
    active: boolean,
    cityId: number,
    client: string[],
    siteClients: IClientSite[]
  ) {
    this.siteId = id;
    this.siteName = name;
    this.streetAddress = streetAddress;
    this.postCode = postCode;
    this.siteCode = siteCode;
    this.cityName = cityName;
    this.County = county;
    this.Town = town;
    this.Active = active;
    this.cityId = cityId;
    this.Client = client;
    this.SiteClients = siteClients;
  }
}
// export { Site };
// export default Site;
